import { Form as AntForm, Checkbox } from 'antd';
import { SchemaOf } from 'yup';
import { Controller, Control } from 'react-hook-form';
import { formHelpers } from '@helpers/formHelpers';

const { Item: FormItem } = AntForm;

interface HSMSCheckBoxProps {
  label?: string;
  name: string;
  defaultValue?: boolean;
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  validationSchema?: SchemaOf<Record<string, unknown> | undefined>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any; // If we are setting proper types we need to get the form values. Not possible since we use this in multiple forms
  onCustomOnChange?: (value) => void;
  className?: string;
}

export const HSMSCheckBox = ({
  label,
  name,
  validationSchema,
  errors,
  disabled,
  control,
  defaultValue,
  onCustomOnChange,
  className,
}: HSMSCheckBoxProps) => (
  <FormItem
    required={validationSchema && formHelpers.isRequired(validationSchema, name)}
    validateStatus={errors && errors[name] ? 'error' : ''}
    help={errors && errors[name]?.message}
    labelCol={{ span: 24 }}
    className={className}
  >
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      onChange={(element) => element[0].target.checked}
      valueName="checked"
      render={({ onChange, value }) => {
        return (
          <Checkbox
            disabled={disabled}
            checked={value}
            onChange={(event) => {
              onChange(event.target.checked);
              if (onCustomOnChange) {
                onCustomOnChange(event.target.checked);
              }
            }}
          >
            {label && label}
          </Checkbox>
        );
      }}
    />
  </FormItem>
);
